'use client'

import ReactMarkdown from 'react-markdown'
import { cn } from '@/lib/utils'

interface BioBlockProps {
  artistBio: string | null
  className?: string
}

export function BioBlock({ artistBio, className }: BioBlockProps) {
  if (!artistBio) return null

  return (
    <div
      className={cn(
        'prose prose-invert prose-sm max-w-none',
        'prose-headings:text-white prose-headings:font-semibold prose-headings:mb-2 prose-headings:mt-4',
        'prose-h1:text-2xl prose-h2:text-xl prose-h3:text-lg',
        'prose-p:text-zinc-300 prose-p:my-2',
        'prose-strong:text-white',
        'prose-em:text-zinc-300',
        'prose-ul:text-zinc-300 prose-ol:text-zinc-300',
        'prose-li:my-1',
        'prose-blockquote:border-l-violet-500 prose-blockquote:text-zinc-400 prose-blockquote:pl-4',
        'prose-a:text-violet-400 prose-a:no-underline hover:prose-a:underline',
        className
      )}
    >
      <ReactMarkdown>{artistBio}</ReactMarkdown>
    </div>
  )
}
